/* Customização: API client para configurações do sistema */
import axios from 'axios';

class ConfigAPI {
  get() {
    return axios.get('/api/v1/config');
  }
}

export default new ConfigAPI();
